function normalize_name(name) {
    return name.toLowerCase().replaceAll(" ", "-")
}
function capitalize_first_letter(s) {
    return s.charAt(0).toUpperCase() + s.slice(1)
}

function calc_leeftijd(year, month, day) {
    let currentDate = new Date();
    let ydiff = currentDate.getFullYear() - year;
    return ydiff - ((was_birthday(month, day)) ? 0 : 1)
}

function zodiac(day, month) {
    // returns the zodiac sign according to day and month ( https://coursesweb.net/ )
    var zodiac = ['', 'Steenbok', 'Waterman', 'Vissen', 'Ram', 'Stier', 'Tweelingen', 'Kreeft', 'Leeuw', 'Maagd', 'Weegschaal', 'Schorpioen', 'Boogschutter', 'Steenbok'];
    var last_day = ['', 19, 18, 20, 20, 21, 21, 22, 22, 21, 22, 21, 20, 19];
    return (day > last_day[month]) ? zodiac[month * 1 + 1] : zodiac[month];
}

function not_man_voornaam(naam, rand) {
    let namen = ["jan", "peter", "hans", "rob", "henk", "paul", "jeroen", "frank", "marcel", "john"]
    let filtered_namen = namen.filter((p) => {
        return !(p === naam.toLowerCase())
    })
    let out = filtered_namen[Math.floor(rand.random() * filtered_namen.length)]
    return capitalize_first_letter(out)
}

function not_vrouw_voornaam(naam, rand) {
    let namen = ["monique", "sandra", "esther", "linda", "petra", "yvonne", "ellen", "anne", "ingrid", "marieke"]
    let filtered_namen = namen.filter((p) => {
        return !(p === naam.toLowerCase())
    })
    let out = filtered_namen[Math.floor(rand.random() * filtered_namen.length)]
    return capitalize_first_letter(out)
}

function not_achternaam(naam, rand) {
    let namen = ["Jansen",
        "Bakker",
        "Janssen",
        "Visser",
        "Smit",
        "Mulder",
        "Bos",
        "Vos",
        "Peters",
        "Hendriks"]
    let filtered_namen = namen.filter((p) => {
        return !(p === naam.toLowerCase())
    })
    let out = filtered_namen[Math.floor(rand.random() * filtered_namen.length)]
    return capitalize_first_letter(out)
}

function not_plaats(plaats, rand) {
    let plaatsen = ["Maastricht", "'s Hertogenbosch", "Middelburg", "Den Haag", "Groningen", "Haarlem", "Utrecht", "Arnhem", "Lelystad", "Zwolle", "Assen", "Leeuwarden", "Groningen"]
    let filtered_plaatsen = plaatsen.filter((p) => {
        return !((normalize_name(p)) === normalize_name(plaats))
    })
    let out = filtered_plaatsen[Math.floor(rand.random() * filtered_plaatsen.length)]

    return capitalize_first_letter(out)
}

function get_provincies(plaats,allow_unknown) {
    let gemeente_to_provincie = {
        "aa-en-hunze": "drenthe",
        "assen": "drenthe",
        "borger-odoorn": "drenthe",
        "coevorden": "drenthe",
        "emmen": "drenthe",
        "hoogeveen": "drenthe",
        "meppel": "drenthe",
        "midden-drenthe": "drenthe",
        "noordenveld": "drenthe",
        "tynaarlo": "drenthe",
        "westerveld": "drenthe",
        "de-wolden": "drenthe",
        "almere": "flevoland",
        "dronten": "flevoland",
        "lelystad": "flevoland",
        "noordoostpolder": "flevoland",
        "urk": "flevoland",
        "zeewolde": "flevoland",
        "achtkarspelen": "friesland",
        "ameland": "friesland",
        "dantumadeel": "friesland",
        "de-friese-meren": "friesland",
        "harlingen": "friesland",
        "heerenveen": "friesland",
        "leeuwarden": "friesland",
        "van": "friesland",
        "ooststellingwerf": "friesland",
        "opsterland": "friesland",
        "schiermonnikoog": "friesland",
        "smallingerland": "friesland",
        "súdwest-fryslân": "friesland",
        "sudwest-fryslan": "friesland",
        "terschelling": "friesland",
        "tietjerksteradeel": "friesland",
        "vlieland": "friesland",
        "waadhoeke": "friesland",
        "weststellingwerf": "friesland",
        "aalten": "gelderland",
        "apeldoorn": "gelderland",
        "arnhem": "gelderland",
        "barneveld": "gelderland",
        "berg-en-dal": "gelderland",
        "berkelland": "gelderland",
        "beuningen": "gelderland",
        "bronckhorst": "gelderland",
        "brummen": "gelderland",
        "buren": "gelderland",
        "culemborg": "gelderland",
        "doesburg": "gelderland",
        "doetinchem": "gelderland",
        "druten": "gelderland",
        "duiven": "gelderland",
        "ede": "gelderland",
        "elburg": "gelderland",
        "epe": "gelderland",
        "ermelo": "gelderland",
        "harderwijk": "gelderland",
        "hattem": "gelderland",
        "heerde": "gelderland",
        "heumen": "gelderland",
        "lingewaard": "gelderland",
        "lochem": "gelderland",
        "maasdriel": "gelderland",
        "montferland": "gelderland",
        "neder-betuwe": "gelderland",
        "nijkerk": "gelderland",
        "nijmegen": "gelderland",
        "nunspeet": "gelderland",
        "oldebroek": "gelderland",
        "oost-gelre": "gelderland",
        "oude-ijsselstreek": "gelderland",
        "overbetuwe": "gelderland",
        "putten": "gelderland",
        "renkum": "gelderland",
        "rheden": "gelderland",
        "rozendaal": "gelderland",
        "scherpenzeel": "gelderland",
        "tiel": "gelderland",
        "voorst": "gelderland",
        "wageningen": "gelderland",
        "west-betuwe": "gelderland",
        "west-maas-en-waal": "gelderland",
        "westervoort": "gelderland",
        "wijchen": "gelderland",
        "winterswijk": "gelderland",
        "zaltbommel": "gelderland",
        "zevenaar": "gelderland",
        "zutphen": "gelderland",
        "eemsmond": "groningen",
        "groningen": "groningen",
        "het-hogeland": "groningen",
        "midden-groningen": "groningen",
        "oldambt": "groningen",
        "pekela": "groningen",
        "stadskanaal": "groningen",
        "veendam": "groningen",
        "westerkwartier": "groningen",
        "westerwolde": "groningen",
        "beek": "limburg",
        "beekdaelen": "limburg",
        "beesel": "limburg",
        "bergen": "noord-holland",
        "brunssum": "limburg",
        "echt-susteren": "limburg",
        "eijsden-margraten": "limburg",
        "gennep": "limburg",
        "gulpen-wittem": "limburg",
        "heerlen": "limburg",
        "horst-aan-de-maas": "limburg",
        "kerkrade": "limburg",
        "landgraaf": "limburg",
        "leudal": "limburg",
        "maasgouw": "limburg",
        "maastricht": "limburg",
        "meerssen": "limburg",
        "mook-en-middelaar": "limburg",
        "nederweert": "limburg",
        "peel-en-maas": "limburg",
        "roerdalen": "limburg",
        "roermond": "limburg",
        "simpelveld": "limburg",
        "sittard-geleen": "limburg",
        "stein": "limburg",
        "vaals": "limburg",
        "valkenburg-aan-de-geul": "limburg",
        "venlo": "limburg",
        "venray": "limburg",
        "voerendaal": "limburg",
        "weert": "limburg",
        "alphen-chaam": "noord-brabant",
        "altena": "noord-brabant",
        "asten": "noord-brabant",
        "baarle-nassau": "noord-brabant",
        "bergeijk": "noord-brabant",
        "bergen-op-zoom": "noord-brabant",
        "bernheze": "noord-brabant",
        "best": "noord-brabant",
        "bladel": "noord-brabant",
        "boekel": "noord-brabant",
        "boxtel": "noord-brabant",
        "breda": "noord-brabant",
        "cranendonck": "noord-brabant",
        "deurne": "noord-brabant",
        "dongen": "noord-brabant",
        "drimmelen": "noord-brabant",
        "eersel": "noord-brabant",
        "eindhoven": "noord-brabant",
        "etten-leur": "noord-brabant",
        "geertruidenberg": "noord-brabant",
        "geldrop-mierlo": "noord-brabant",
        "gemert-bakel": "noord-brabant",
        "gilze-en-rijen": "noord-brabant",
        "goirle": "noord-brabant",
        "halderberge": "noord-brabant",
        "heeze-leende": "noord-brabant",
        "helmond": "noord-brabant",
        "'s-hertogenbosch": "noord-brabant",
        "heusden": "noord-brabant",
        "hilvarenbeek": "noord-brabant",
        "laarbeek": "noord-brabant",
        "land-van-cuijk": "noord-brabant",
        "loon-op-zand": "noord-brabant",
        "maashorst": "noord-brabant",
        "meierijstad": "noord-brabant",
        "moerdijk": "noord-brabant",
        "": "noord-brabant",
        "oirschot": "noord-brabant",
        "oisterwijk": "noord-brabant",
        "oosterhout": "noord-brabant",
        "oss": "noord-brabant",
        "reusel-de-mierden": "noord-brabant",
        "roosendaal": "noord-brabant",
        "rucphen": "noord-brabant",
        "sint-michielsgestel": "noord-brabant",
        "someren": "noord-brabant",
        "son-en-breugel": "noord-brabant",
        "steenbergen": "noord-brabant",
        "tilburg": "noord-brabant",
        "valkenswaard": "noord-brabant",
        "veldhoven": "noord-brabant",
        "vught": "noord-brabant",
        "waalre": "noord-brabant",
        "waalwijk": "noord-brabant",
        "woensdrecht": "noord-brabant",
        "zundert": "noord-brabant",
        "aalsmeer": "noord-holland",
        "alkmaar": "noord-holland",
        "amstelveen": "noord-holland",
        "amsterdam": "noord-holland",
        "beverwijk": "noord-holland",
        "blaricum": "noord-holland",
        "bloemendaal": "noord-holland",
        "castricum": "noord-holland",
        "den-helder": "noord-holland",
        "diemen": "noord-holland",
        "dijk-en-waard": "noord-holland",
        "drechterland": "noord-holland",
        "edam-volendam": "noord-holland",
        "enkhuizen": "noord-holland",
        "gooise-meren": "noord-holland",
        "haarlem": "noord-holland",
        "haarlemmermeer": "noord-holland",
        "heemskerk": "noord-holland",
        "heemstede": "noord-holland",
        "heiloo": "noord-holland",
        "hilversum": "noord-holland",
        "hollands-kroon": "noord-holland",
        "hoorn": "noord-holland",
        "huizen": "noord-holland",
        "koggenland": "noord-holland",
        "landsmeer": "noord-holland",
        "laren": "noord-holland",
        "medemblik": "noord-holland",
        "oostzaan": "noord-holland",
        "opmeer": "noord-holland",
        "ouder-amstel": "noord-holland",
        "purmerend": "noord-holland",
        "schagen": "noord-holland",
        "stede-broec": "noord-holland",
        "texel": "noord-holland",
        "uitgeest": "noord-holland",
        "uithoorn": "noord-holland",
        "velsen": "noord-holland",
        "waterland": "noord-holland",
        "wijdemeren": "noord-holland",
        "wormerland": "noord-holland",
        "zaanstad": "noord-holland",
        "zandvoort": "noord-holland",
        "almelo": "overijssel",
        "borne": "overijssel",
        "dalfsen": "overijssel",
        "deventer": "overijssel",
        "dinkelland": "overijssel",
        "enschede": "overijssel",
        "haaksbergen": "overijssel",
        "hardenberg": "overijssel",
        "hellendoorn": "overijssel",
        "hengelo": "overijssel",
        "hof-van-twente": "overijssel",
        "kampen": "overijssel",
        "losser": "overijssel",
        "oldenzaal": "overijssel",
        "olst-wijhe": "overijssel",
        "ommen": "overijssel",
        "raalte": "overijssel",
        "rijssen-holten": "overijssel",
        "staphorst": "overijssel",
        "steenwijkerland": "overijssel",
        "tubbergen": "overijssel",
        "twenterand": "overijssel",
        "wierden": "overijssel",
        "zwartewaterland": "overijssel",
        "zwolle": "overijssel",
        "amersfoort": "utrecht",
        "baarn": "utrecht",
        "de-bilt": "utrecht",
        "bunnik": "utrecht",
        "bunschoten": "utrecht",
        "eemnes": "utrecht",
        "houten": "utrecht",
        "ijsselstein": "utrecht",
        "leusden": "utrecht",
        "lopik": "utrecht",
        "montfoort": "utrecht",
        "nieuwegein": "utrecht",
        "oudewater": "utrecht",
        "renswoude": "utrecht",
        "rhenen": "utrecht",
        "de-ronde-venen": "utrecht",
        "soest": "utrecht",
        "stichtse-vecht": "utrecht",
        "utrecht": "utrecht",
        "utrechtse-heuvelrug": "utrecht",
        "veenendaal": "utrecht",
        "vijfheerenlanden": "utrecht",
        "wijk-bij-duurstede": "utrecht",
        "woerden": "utrecht",
        "woudenberg": "utrecht",
        "zeist": "utrecht",
        "borsele": "zeeland",
        "goes": "zeeland",
        "hulst": "zeeland",
        "kapelle": "zeeland",
        "middelburg": "zeeland",
        "noord-beveland": "zeeland",
        "reimerswaal": "zeeland",
        "schouwen-duiveland": "zeeland",
        "sluis": "zeeland",
        "terneuzen": "zeeland",
        "tholen": "zeeland",
        "veere": "zeeland",
        "vlissingen": "zeeland",
        "alblasserdam": "zuid-holland",
        "albrandswaard": "zuid-holland",
        "alphen-aan-den-rijn": "zuid-holland",
        "barendrecht": "zuid-holland",
        "bodegraven-reeuwijk": "zuid-holland",
        "brielle": "zuid-holland",
        "capelle-aan-den-ijssel": "zuid-holland",
        "delft": "zuid-holland",
        "den-haag": "zuid-holland",
        "dordrecht": "zuid-holland",
        "goeree-overflakkee": "zuid-holland",
        "gorinchem": "zuid-holland",
        "gouda": "zuid-holland",
        "hardinxveld-giessendam": "zuid-holland",
        "hellevoetsluis": "zuid-holland",
        "hendrik-ido-ambacht": "zuid-holland",
        "hillegom": "zuid-holland",
        "hoeksche-waard": "zuid-holland",
        "kaag-en-braassem": "zuid-holland",
        "alkemade": "zuid-holland",
        "katwijk": "zuid-holland",
        "krimpen-aan-den-ijssel": "zuid-holland",
        "krimpenerwaard": "zuid-holland",
        "lansingerland": "zuid-holland",
        "leiden": "zuid-holland",
        "leiderdorp": "zuid-holland",
        "leidschendam-voorburg": "zuid-holland",
        "lisse": "zuid-holland",
        "maassluis": "zuid-holland",
        "midden-delfland": "zuid-holland",
        "molenlanden": "zuid-holland",
        "nieuwkoop": "zuid-holland",
        "nissewaard": "zuid-holland",
        "noordwijk": "zuid-holland",
        "oegstgeest": "zuid-holland",
        "papendrecht": "zuid-holland",
        "pijnacker-nootdorp": "zuid-holland",
        "ridderkerk": "zuid-holland",
        "rijswijk": "zuid-holland",
        "rotterdam": "zuid-holland",
        "schiedam": "zuid-holland",
        "sliedrecht": "zuid-holland",
        "teylingen": "zuid-holland",
        "vlaardingen": "zuid-holland",
        "voorschoten": "zuid-holland",
        "waddinxveen": "zuid-holland",
        "wassenaar": "zuid-holland",
        "westland": "zuid-holland",
        "westvoorne": "zuid-holland",
        "zoetermeer": "zuid-holland",
        "zoeterwoude": "zuid-holland",
        "zuidplas": "zuid-holland",
        "zwijndrecht": "zuid-holland",
        "voorhout": "zuid-holland",
        "sassenheim": "zuid-holland",
        "warmond": "zuid-holland",
    }
    let provincie = gemeente_to_provincie[normalize_name(plaats)]
    if (!provincie && allow_unknown) {
        return "Buiten Nederland"
    } else {
        return provincie
    }
}

let provincies_info = {
    "utrecht": {hoofdstad: "Utrecht", dichtbij_zee: false},
    "zuid-holland": {hoofdstad: "Den Haag", dichtbij_zee: true},
    "zeeland": {hoofdstad: "Middelburg", dichtbij_zee: true},
    "overijssel": {hoofdstad: "Zwolle", dichtbij_zee: false},
    "noord-holland": {hoofdstad: "Haarlem", dichtbij_zee: true},
    "noord-brabant": {hoofdstad: "'s Hertogenbosch", dichtbij_zee: false},
    "limburg": {hoofdstad: "Maastricht", dichtbij_zee: false},
    "groningen": {hoofdstad: "Groningen", dichtbij_zee: true},
    "gelderland": {hoofdstad: "Arnhem", dichtbij_zee: false},
    "friesland": {hoofdstad: "Leeuwarden", dichtbij_zee: true},
    "flevoland": {hoofdstad: "Lelystad", dichtbij_zee: false},
    "drenthe": {hoofdstad: "Assen", dichtbij_zee: false},
}

function dichtbij_zee(provincie) {

    return provincies_info[provincie].dichtbij_zee

}

function get_initials(firstname, lastname) {
    let f = firstname.charAt(0)
    let d = lastname.toLowerCase()
        .replaceAll("van ", "")
        .replaceAll("der ", "")
        .replaceAll("de ", "")
        .charAt(0)
    return `${f.toUpperCase()}.${d.toUpperCase()}.`
}

function contains_double_letters(name) {
    let tmp = name.toLowerCase();
    let prev = null;
    for (let i = 0; i < tmp.length; i += 1) {
        if (prev === tmp.charAt(i)) {
            return true;
        }
        prev = tmp.charAt(i)
    }
    return false;
}

function get_provincie_hoofdstad(provincie) {
    let b = provincies_info[normalize_name(provincie)]
    return b.hoofdstad
}

function was_birthday(month, day) {
    let c = new Date();
    return c >= (new Date(c.getFullYear(), month - 1, day))
}

function not_street(straat, rand) {
    let straten = ["kerkstraat", "schoolstraat", "molenstraat", "dorpsstraat", "molenweg", "julianastraat", "parallelweg", "nieuwstraat", "wilhelminastraat", "sportlaan", "beatrixstraat", "kastanjelaan", "stationsweg"]
    let filtered_straten = straten.filter((p) => {
        return !(p === straat.toLowerCase())
    })
    let out = filtered_straten[Math.floor(rand.random() * filtered_straten.length)]
    return out.charAt(0).toUpperCase() + out.slice(1)
}

function to_maand_naam(m) {
    return ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"][m - 1]
}

function clamped_reduce_by(val, low, high, red) {
    let mod = high - low
    let newval = ((val - (low + red)) % (high - low))
    while (newval < 0) {
        newval += mod
    }
    return newval + low
}

function shuffleArray(arr, rand) {
    return arr
        .map(value => ({value, sort: rand.random()}))
        .sort((a, b) => a.sort - b.sort)
        .map(({value}) => value)
}

function transformQuestions(questions) {
    shuffleArray(questions)
    return shuffleArray(questions).slice(0, 1).map((q) => {
        return {
            header: "Ja of Nee",
            body: q[0],
            answers: ["ja", "nee"],
            correct: (q[2]) ? "ja" : "nee"
        }
    })
}


function Factorial(n) {
    if (n === 0) {
        return 1;
    }
    else {
        return n * Factorial( n - 1 );
    }
}


let question_order = [
    // block 1
    {"challenge": false, "answer": true, "qtype": "simple", "type_id": 0},
    {"challenge": false, "answer": false, "qtype": "control", "type_id": 0},
    {"challenge": true, "answer": false, "qtype": "control", "type_id": 1},
    {"challenge": true, "answer": true, "qtype": "control", "type_id": 0},
    {"challenge": false, "answer": false, "qtype": "hard", "type_id": 0},
    {"challenge": true, "answer": false, "qtype": "hard", "type_id": 1},
    {"challenge": true, "answer": true, "qtype": "hard", "type_id": 0},
    {"challenge": false, "answer": true, "qtype": "control", "type_id": 1},
    {"challenge": false, "answer": false, "qtype": "simple", "type_id": 0},
    {"challenge": true, "answer": false, "qtype": "simple", "type_id": 1},
    {"challenge": true, "answer": true, "qtype": "simple", "type_id": 1},
    {"challenge": false, "answer": true, "qtype": "hard", "type_id": 1},

    // block 2
    {"challenge": false, "answer": true, "qtype": "hard", "type_id": 2},
    {"challenge": false, "answer": false, "qtype": "hard", "type_id": 2},
    {"challenge": true, "answer": false, "qtype": "control", "type_id": 2},
    {"challenge": true, "answer": true, "qtype": "control", "type_id": 2},
    {"challenge": false, "answer": false, "qtype": "control", "type_id": 3},
    {"challenge": true, "answer": false, "qtype": "hard", "type_id": 3},
    {"challenge": true, "answer": true, "qtype": "hard", "type_id": 3},
    {"challenge": false, "answer": true, "qtype": "control", "type_id": 3},
    {"challenge": false, "answer": false, "qtype": "simple", "type_id": 2},
    {"challenge": true, "answer": false, "qtype": "simple", "type_id": 3},
    {"challenge": true, "answer": true, "qtype": "simple", "type_id": 2},
    {"challenge": false, "answer": true, "qtype": "simple", "type_id": 3},

    // block 3
    {"challenge": false, "answer": true, "qtype": "control", "type_id": 4},
    {"challenge": false, "answer": false, "qtype": "control", "type_id": 4},
    {"challenge": true, "answer": false, "qtype": "control", "type_id": 5},
    {"challenge": true, "answer": true, "qtype": "control", "type_id": 5},
    {"challenge": false, "answer": false, "qtype": "hard", "type_id": 4},
    {"challenge": true, "answer": false, "qtype": "hard", "type_id": 5},
    {"challenge": true, "answer": true, "qtype": "hard", "type_id": 4},
    {"challenge": false, "answer": true, "qtype": "hard", "type_id": 5},
    {"challenge": false, "answer": false, "qtype": "simple", "type_id": 4},
    {"challenge": true, "answer": false, "qtype": "simple", "type_id": 5},
    {"challenge": true, "answer": true, "qtype": "simple", "type_id": 4},
    {"challenge": false, "answer": true, "qtype": "simple", "type_id": 5},

    // block 4
    {"challenge": false, "answer": false, "qtype": "simple", "type_id": 6},
    {"challenge": true, "answer": false, "qtype": "control", "type_id": 6},
    {"challenge": true, "answer": true, "qtype": "control", "type_id": 6},
    {"challenge": false, "answer": true, "qtype": "control", "type_id": 7},
    {"challenge": false, "answer": false, "qtype": "control", "type_id": 7},
    {"challenge": true, "answer": false, "qtype": "hard", "type_id": 6},
    {"challenge": true, "answer": true, "qtype": "hard", "type_id": 6},
    {"challenge": false, "answer": true, "qtype": "hard", "type_id": 7},
    {"challenge": false, "answer": false, "qtype": "hard", "type_id": 7},
    {"challenge": true, "answer": false, "qtype": "simple", "type_id": 7},
    {"challenge": true, "answer": true, "qtype": "simple", "type_id": 6},
    {"challenge": false, "answer": true, "qtype": "simple", "type_id": 7},

    // block 5
    {"challenge": false, "answer": false, "qtype": "hard", "type_id": 8},
    {"challenge": true, "answer": false, "qtype": "control", "type_id": 8},
    {"challenge": true, "answer": true, "qtype": "control", "type_id": 8},
    {"challenge": false, "answer": true, "qtype": "control", "type_id": 9},
    {"challenge": false, "answer": false, "qtype": "control", "type_id": 9},
    {"challenge": true, "answer": false, "qtype": "hard", "type_id": 9},
    {"challenge": true, "answer": true, "qtype": "hard", "type_id": 8},
    {"challenge": false, "answer": true, "qtype": "hard", "type_id": 9},
    {"challenge": false, "answer": false, "qtype": "simple", "type_id": 8},
    {"challenge": true, "answer": false, "qtype": "simple", "type_id": 9},
    {"challenge": true, "answer": true, "qtype": "simple", "type_id": 8},
    {"challenge": false, "answer": true, "qtype": "simple", "type_id": 9},
]


export {
    get_provincies,
    get_provincie_hoofdstad,
    calc_leeftijd,
    zodiac,
    transformQuestions,
    clamped_reduce_by,
    not_plaats,
    not_street,
    not_man_voornaam,
    not_achternaam,
    not_vrouw_voornaam,
    to_maand_naam, get_initials, contains_double_letters,
    was_birthday,
    dichtbij_zee,
    shuffleArray,
    Factorial,
    normalize_name,
    capitalize_first_letter,
    question_order
}
